import Tabs from 'choerodon-ui/lib/tabs';
export default Tabs;
